@for (entity of entities(); track entity; let i = $index) {
    <div
        role="button"     
        (click)="listItemClick.emit(entity)" stop-click-bubble>
        <ng-container                            
            [ngTemplateOutlet]="template()"
            [ngTemplateOutletContext]="{ $implicit: entity, item: entity }" />
    </div>
} @empty {
    <!--//TODO:DIW:Allow usage of custom empty template-->
    <div 
        class="alert animate__animated animate__fadeIn animate__faster px-3 rounded-0 clip3 py-1 alert-warning d-flex align-items-center">
        <span class="material-icons font-9 me-2">warning</span>
        No Data Found
    </div>
}